import { colors } from "@areahub/theme";

/**
 *  Colors determined from [here](https://www.arcgis.com/home/webmap/viewer.html?url=https://services.arcgis.com/XG15cJAlne2vxtgt/ArcGIS/rest/services/National_Risk_Index_Annualized_Frequency_Coastal_Flooding/FeatureServer/1&source=sd)
 *  */
const HAIL_STOPS = [
  -9999,
  colors.blueGray[200],
  0,
  colors.green[300],
  1.2,
  colors.amber[300],
  2.89,
  colors.orange[500],
  4.76,
  colors.red[500],
  7.7,
  colors.red[600],
];

/**
 *  Legend determined from [here](https://www.arcgis.com/home/webmap/viewer.html?url=https://services.arcgis.com/XG15cJAlne2vxtgt/ArcGIS/rest/services/National_Risk_Index_Annualized_Frequency_Coastal_Flooding/FeatureServer/1&source=sd)
 */
const getLegendRows = () => {
  return [
    ["> 7.7 – 12.8", 11],
    ["> 4.76 – 7.7", 9],
    ["> 2.89 – 4.76", 7],
    ["> 1.2 – 2.89", 5],
    ["0 – 1.2", 3],
    ["Not Applicable", 1],
  ].map((row) => ({
    icon: "draw-polygon",
    label: row[0] === "Not Applicable" ? row[0] : row[0] + " events/yr",
    color: HAIL_STOPS[row[1] as number],
  }));
};

export const hail = {
  stops: HAIL_STOPS,
  props: getLegendRows(),
};
